import { isActDetailResponse, isActsListResponse, } from '@urbanik/api-contracts';
export class ActsApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'ActsApiError';
    }
}
const url = (base, path) => `${base.replace(/\/$/, '')}${path}`;
const json = async (response) => {
    try {
        return await response.json();
    }
    catch {
        throw new ActsApiError('invalid', 'El servidor devolvió una respuesta inválida.');
    }
};
const failure = (response, body) => {
    const message = typeof body === 'object' &&
        body !== null &&
        typeof body.message === 'string'
        ? body.message
        : 'No pudimos completar la operación.';
    throw new ActsApiError(response.status === 401
        ? 'unauthorized'
        : response.status === 403
            ? 'forbidden'
            : response.status === 400
                ? 'validation'
                : response.status === 404
                    ? 'not-found'
                    : response.status === 409
                        ? 'conflict'
                        : 'unavailable', message);
};
export async function getActs(base, signal) {
    let r;
    try {
        r = await fetch(url(base, '/identity/governance/acts'), {
            credentials: 'include',
            headers: { Accept: 'application/json' },
            signal: signal ?? null,
        });
    }
    catch {
        throw new ActsApiError('unavailable', 'No pudimos consultar las actas.');
    }
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActsListResponse(b))
        throw new ActsApiError('invalid', 'El contrato de actas no es válido.');
    return b;
}
export async function getAct(base, id) {
    const r = await fetch(url(base, `/identity/governance/acts/${encodeURIComponent(id)}`), {
        credentials: 'include',
        headers: { Accept: 'application/json' },
    });
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActDetailResponse(b))
        throw new ActsApiError('invalid', 'El detalle del acta no es válido.');
    return b;
}
export async function createAct(base, input) {
    const r = await fetch(url(base, '/identity/governance/acts'), {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActDetailResponse(b))
        throw new ActsApiError('invalid', 'El acta creada no es válida.');
    return b;
}
export async function updateAct(base, id, input) {
    const r = await fetch(url(base, `/identity/governance/acts/${encodeURIComponent(id)}`), {
        method: 'PATCH',
        credentials: 'include',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActDetailResponse(b))
        throw new ActsApiError('invalid', 'El acta actualizada no es válida.');
    return b;
}
export async function deleteAct(base, id) {
    const r = await fetch(url(base, `/identity/governance/acts/${encodeURIComponent(id)}`), {
        method: 'DELETE',
        credentials: 'include',
        headers: { Accept: 'application/json' },
    });
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActDetailResponse(b))
        throw new ActsApiError('invalid', 'La respuesta de papelera no es válida.');
    return b;
}
export async function restoreAct(base, id) {
    const r = await fetch(url(base, `/identity/governance/acts/${encodeURIComponent(id)}/restore`), {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json' },
    });
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActDetailResponse(b))
        throw new ActsApiError('invalid', 'La respuesta de restauración no es válida.');
    return b;
}
export async function uploadActDocument(base, id, file) {
    const r = await fetch(url(base, `/identity/governance/acts/${encodeURIComponent(id)}/document`), {
        method: 'PUT',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/pdf',
            'x-urbanik-file-name': encodeURIComponent(file.name),
        },
        body: file,
    });
    const b = await json(r);
    if (!r.ok)
        failure(r, b);
    if (!isActDetailResponse(b))
        throw new ActsApiError('invalid', 'El documento cargado no es válido.');
    return b;
}
export async function downloadActDocument(base, id) {
    const r = await fetch(url(base, `/identity/governance/acts/${encodeURIComponent(id)}/document`), {
        credentials: 'include',
    });
    if (!r.ok)
        failure(r, await json(r));
    const disposition = r.headers.get('content-disposition') ?? '';
    return {
        blob: await r.blob(),
        fileName: decodeURIComponent(disposition.match(/filename\*=UTF-8''([^;]+)/)?.[1] ?? 'acta.pdf'),
    };
}
